import { render, staticRenderFns } from "./SurveyBeginStartLibras.vue?vue&type=template&id=fbe46328&scoped=true&"
import script from "./SurveyBeginStartLibras.vue?vue&type=script&lang=js&"
export * from "./SurveyBeginStartLibras.vue?vue&type=script&lang=js&"
import style0 from "./SurveyBeginStartLibras.vue?vue&type=style&index=0&id=fbe46328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe46328",
  null
  
)

export default component.exports